import config from "../permission/config.json";
import { getResource } from "./getResourcePermission";

/**
 * Who sees the Action Hub header button: anyone with Pending Task read access.
 * When the company has a SuperAdmin plan configured, the route itself is plan
 * gated on the "pending_task" slug (routes/newRoutes.js), so the button is hidden
 * too rather than linking to a page that would bounce the user.
 */
const canViewActionHub = () => {
  if (!getResource(config.RESOURCES.PENDING_TASK, ["read"])) return false;
  try {
    const raw = JSON.parse(localStorage.getItem("sidebarModuleAccess") || "[]");
    if (Array.isArray(raw) && raw.length > 0) return raw.includes("pending_task");
  } catch {
    // unreadable plan cache - fall back to RBAC only
  }
  return true;
};

export default canViewActionHub;
